export enum ResourceState {
  Meta = 1,
  Summary = 2,
  Detail = 3,
}
